// extracted by mini-css-extract-plugin
export var article = "multimedia-module--article--d2999";
export var articleSignUpEmbedContainer = "multimedia-module--articleSignUpEmbedContainer--fb8ce";
export var asSeenOn = "multimedia-module--asSeenOn--10bbd";
export var attribution = "multimedia-module--attribution--0010c";
export var authors = "multimedia-module--authors--baefe";
export var body = "multimedia-module--body--f5c35";
export var contentActions = "multimedia-module--content-actions--87d0c";
export var date = "multimedia-module--date--449b6";
export var deck = "multimedia-module--deck--88be5";
export var likeContainer = "multimedia-module--likeContainer--804a2";
export var meta = "multimedia-module--meta--8ead1";
export var moreContent = "multimedia-module--moreContent--23467";
export var pipe = "multimedia-module--pipe--977f9";
export var primaryImage = "multimedia-module--primaryImage--69000";
export var root = "multimedia-module--root--5e2ae";
export var tags = "multimedia-module--tags--fe7c9";
export var title = "multimedia-module--title--bfa13";